export default {
    'Menu': 'Menü'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/oncanvas/translations/de.js
// module id = 435
// module chunks = 0